import {useEffect, useState} from "react";
import {useSelector,useDispatch} from "react-redux";
import {getExtraPodcastParameters} from "../../utils/action"
import "../../../index.css"
import PodcastClass from "./const";
const ToggleAddPodcast = () => {
    const audio = useSelector((state)=>state.ReducerGetPodcastData.podcastAudio)
    const thumb = useSelector((state)=>state.ReducerGetPodcastData.secondThumbData);
   // const id = useSelector((state)=>state.ReducerGetPodcastData.tus_id);
    const video = useSelector((state)=>state.ReducerGetPodcastData.podcastVideo);
   // const podItems = useSelector((state)=>state.ReducerGetPodcastData.podcastItems_byId);
   //  let titleItems = podItems?.map(podcast=>podcast.title);
   //  let descrItems = podItems?.map(podcast=>podcast.description);
     const videoForPodcastItem = useSelector(state=>state.ReducerGetPodcastData.podcastItems.video);
    // const audioForPodcastItem = useSelector(state=>state.ReducerGetPodcastData.podcastVideo);
    const dispatch = useDispatch();
    const [title] = useState("");
    const [description] = useState("");
    const [vignette,setVignette]=useState("");
    const [podcastItemid,setpodcastItemid] = useState("");
   

    useEffect(()=>{
        let pIid = JSON.parse(PodcastClass.getId())?.podcastItemId
        setpodcastItemid(pIid);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    useEffect(()=>{
        setVignette(thumb);
        let titleForPodcastItem = "";
        if(title.length <= 0 ) {
            titleForPodcastItem = videoForPodcastItem;
        }
        else if(title.length > 0 ) {
            titleForPodcastItem = title;
        }
        dispatch(getExtraPodcastParameters(titleForPodcastItem,description,vignette,audio,video,podcastItemid))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[title, description, vignette, thumb, videoForPodcastItem, audio])

}

export default ToggleAddPodcast;